export const ORDER_STATUS = {
  ORDER_STATUS_DRAFT: 1,
  ORDER_STATUS_OVERDUE: 2,
  ORDER_STATUS_DECLARED: 5,
  ORDER_STATUS_CONCLUDED: 10,
  ORDER_STATUS_CANCELED: -10,
  ORDER_STATUS_NEW: -1,
};
